import {Box, Divider, Grid} from '@material-ui/core'
import {AttachFile, InsertPhoto, PictureAsPdf} from '@material-ui/icons'
import _t, {_} from 'i18n'
import React, {Fragment} from 'react'
import {Button, Form} from 'react-bootstrap'

import {Container, Title} from '../styles'

const formatCurrency = (amount) =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(amount)

const CityRevision = ({city, location, onSubmit, submiting}) => {
  return (
    <Container style={{padding: 0}}>
      <Box marginBottom="60px" maxWidth="654px" m="auto" width="100%">
        <Grid container direction="column">
          <Box>
            <Box marginBottom="5px">
              <Title>{_`INFORMAÇÕES BÁSICAS SOBRE O MUNICÍPIO`}</Title>
            </Box>
            <Box display="flex" width="fit-content" flexDirection="column" mb="20px">
              <Form.Label>
                {city.name} / {city.state.uf}
              </Form.Label>
            </Box>

            <Divider />
          </Box>

          <BlockDetail title={_`INFORMAÇÕES BÁSICAS`} items={[{label: _`Resumo`, value: location.description}]} />

          <BlockDetail
            title={_`VOCAÇÃO REGIONAL`}
            items={[
              {
                label: _`Vocações`,
                value: location.vocations.length
                  ? location.vocations.map((v) => (v.description ? v.description : v)).join(', ')
                  : _`Nenhuma selecionada`,
              },
            ]}
          />

          {location.benefits.length > 0 && (
            <BlockDetailBenefityList title={_`INCENTIVOS DADO PELO MUNICÍPIO`} items={location.benefits} />
          )}

          <BlockDetail
            title={_`CONTATO`}
            items={[
              {label: _`Nome para contato`, value: location.contacts[0]?.name},
              {label: _`Cargo`, value: location.contacts[0]?.responsibility},
              {label: _`Telefone`, value: location.contacts[0]?.phone},
              {label: _`E-mail`, value: location.contacts[0]?.email},
              {label: _`Site`, value: location.contacts[0]?.linkedin},
            ]}
          />

          {location.city_hall && (
            <BlockDetail
              title={_`Sede da Prefeitura`}
              items={[
                {label: _`CEP`, value: location.city_hall?.zip},
                {label: _`Logradouro`, value: location.city_hall?.street},
                {label: _`Número`, value: location.city_hall?.number},
                {label: _`Bairro`, value: location.city_hall?.neighborhood},
                {label: _`Cidade`, value: location.city_hall?.city?.name},
                {label: _`UF`, value: location.city_hall?.city?.state?.uf},
              ]}
            />
          )}

          {/*location?.industrial_area?.geojson && (
            <BlockDetail
              title={_`Área Industrial`}
              items={[{label: _`GeoJSON da área`, value: location.industrial_area.geojson}]}
            />
          )*/}

          {location.multimedia?.length > 0 && (
            <Box pt="30px">
              <Box mb="22px">
                <Title>{_`ANEXOS`}</Title>
              </Box>
              <Box display="flex" gridGap="15px" flexWrap="wrap" justifyContent="space-between">
                {location.multimedia.map((file, i) => (
                  <Tip key={i} description={file.name} />
                ))}
              </Box>
            </Box>
          )}

          <Box display="flex" marginTop="70px" marginBottom="70px">
            <Box>
              <Button onClick={() => onSubmit(false)} disabled={submiting}>{_`SALVAR E CONCLUIR EDIÇÃO`}</Button>
            </Box>
          </Box>
        </Grid>
      </Box>
    </Container>
  )
}

const BlockDetail = ({title, items}) => {
  return (
    <Fragment>
      <Box pt="30px" pb="30px">
        <Box mb="5px">
          <Title>{title}</Title>
        </Box>

        {items?.map((item, i) => (
          <Detail key={i} {...item} />
        ))}
      </Box>
      <Divider />
    </Fragment>
  )
}

const BlockDetailBenefityList = ({title, items}) => {
  return (
    <Fragment>
      <Box pt="30px" pb="30px">
        <Box mb="5px">
          <Title>{title}</Title>
        </Box>

        {items?.map((item, i) => (
          <Detail key={i} label={item.type.toUpperCase()} value={item.description} />
        ))}
      </Box>
      <Divider />
    </Fragment>
  )
}

const BlockDetailBenefity = ({title, items}) => {
  return items.map((item, i) => {
    if (item.type === 'terreno') {
      return (
        <Fragment key={i}>
          <Box pt="30px" pb="30px">
            <Box mb="5px">
              <Title>{_`SOBRE O TERRENO`}</Title>
            </Box>
            <Detail label={_`Identificação`} value={item.identification} />
            <Detail label={_`Área'`} value={item.area} />
            <Detail
              label={_`Valor Estimado`}
              value={item.estimated_value.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                style: 'currency',
                currency: 'BRL',
              })}
            />
            <Detail label={_`Restrições`} value={item.restrictions} />
            <Detail label={_`URL Mapa`} value={item.url_map} />
          </Box>
          <Divider />
          <Box pt="30px" pb="30px">
            <Box mb="5px">
              <Title>{_`DETALHAMENTO`}</Title>
            </Box>
            <Detail value={item.description} />
          </Box>
          <Divider />
        </Fragment>
      )
    }

    return (
      <Fragment key={i}>
        <Box pt="30px" pb="30px">
          <Box mb="5px">
            <Title>{_t('SOBRE INCENTIVO {type}', {type: item.type.toUpperCase()})}</Title>
          </Box>
          <Detail value={item.description} />
        </Box>
        <Divider />
      </Fragment>
    )
  })
}

const Detail = ({label, value}) => {
  const valueIsArray = Array.isArray(value)
  const valueIsString = typeof value === 'string'

  const valueString = valueIsString ? value : undefined
  const valueArray = valueIsArray ? JSON.stringify(value) : undefined
  const valueOther = !valueIsArray && !valueIsString ? JSON.stringify(value) : undefined

  const hasValue = !!(valueArray || valueString || valueOther)

  const separator = hasValue ? ':' : null
  const val = valueString ?? valueArray ?? valueOther
  return (
    <Box
      style={{
        color: '#1D1D1D',
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '14px',
      }}>
      <b>
        {label}
        {separator}&nbsp;
      </b>
      {val}
    </Box>
  )
}

const Tip = ({description}) => {
  return (
    <Box
      padding="2px 10px"
      width="fit-content"
      fontSize="12px"
      borderRadius="10px"
      display="flex"
      alignItems="center"
      style={{backgroundColor: '#1E7BE10C'}}>
      {(function () {
        switch (description.split('.')[description.split('.').length - 1]) {
          case 'pdf':
            return <PictureAsPdf />
          case 'jpg':
          case 'jpeg':
          case 'png':
          case 'bmp':
          case 'gif':
            return <InsertPhoto />
          case 'doc':
          case 'docx':
          case 'xls':
          case 'xlsx':
          case 'txt':
            return <AttachFile />
          default:
            return <AttachFile />
        }
      })()}
      <p style={{margin: '0 0 0 4px'}}>{description}</p>
    </Box>
  )
}

export default CityRevision
